<template>
    <div id="sve" class="d-flex">
    <MainBarMenuV2/>
    <div class="layout-content container-fluid">
      <HeadingUser />
      <div class="col-10 mx-auto my-5">
        <Typography text="👋🏻 Hola David" variant="h3" class="pt-4"/>
        <Typography text="Te damos la bienvenida a tu herramienta de monitoreo y evaluación" variant="h2"/>
        <div class="card_welcome ml-4">
          <Typography text="Puede dirigir al usuario a las evaluaciones" variant="h3"/>
          <Typography text="Siempre que realices una actualización al proceso recuerda evaluarlo, siempre puedes descargar el reporte actualizado." variant="body" class="w-75"/>
          <Button label="Empezar" variant="primary" small="true" :onClick="redirect"/>
        </div>
      </div>
    </div>
   </div>  
</template>

<script>
import useControllers from "@/controllers";
  const { useScreenHooks } = useControllers();
  const { useLegal } = useScreenHooks();
  const { useDashboard } = useLegal();

  export default useDashboard;
</script>

<style scope>
  .card_welcome {
    background: #ECECFF;
    border: 1px solid #ECEFF1;
    border-radius: 16px;
    height: 288px;
    padding: 58px 32px;
    background-image: url("../../../assets/images/legal/img-card-welcome.webp");
    background-repeat: no-repeat;
    background-position-x: right;
    margin-top: 62px;
  }
</style>